
export class OrgHeadends {
  headend: number;
  regionId: number;
  description: string;

  constructor(json?: any) {
    this.regionId = json.regionId;
    this.description = json.description;
    this.headend = json.headend;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/models/OrgHeadends.ts